import type { PropsWithChildren } from 'react';
import { useCssHandles } from '../../../utils/functions';

const SELLERS_CSS_HANDLES = ['sellerHeadCell', 'sellerHeadText'] as const;

interface Props {
	title: string;
	componentId?: string;
	blockClass?: string;
}

function SellerHeadCell({ title, children, componentId, blockClass }: PropsWithChildren<Props>) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div data-selection={componentId} className={`${handles.sellerHeadCell} w-20`}>
			{title ? <h5 className={`${handles.sellerHeadText} items-center tc ph6 pv4 ma0 t-heading-6`}>{title}</h5> : null}
			{children}
		</div>
	);
}

export default SellerHeadCell;
